import { RegionShared } from "@1games-ru/region-shared";
import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { RootState } from "@/core/store";

export interface PlayerState {
  playerInfo: null | typeof RegionShared.Client.Responses.GetPlayerResponse;
}

const initialState: PlayerState = {
  playerInfo: null,
};

const playerSlice = createSlice({
  name: "player",
  initialState,
  reducers: {
    setPlayerInfo(
      state,
      action: PayloadAction<typeof RegionShared.Client.Responses.GetPlayerResponse | null>,
    ) {
      state.playerInfo = action.payload;
    },
  },
});

export const playerInfoSelector = (
  state: RootState,
): typeof RegionShared.Client.Responses.GetPlayerResponse => state.player.playerInfo;

export const playerReducer = playerSlice.reducer;

export const { setPlayerInfo } = playerSlice.actions;
